import React from 'react';
import { getClickAttrs } from '../../Analytics/gtag';

const CtaCard = (props) => {
    const { data, className, force, onCtaClick, clickContext, clickLocation, clickCategory, 'data-testid': dataTestId } = props;
    const { title, subTitle, iconCardSubTitle, ctaText } = data || {};
    const { iconCard } = force || {};

    return (
        <div className={`utr-card cta-card ${className || ''} ${iconCard ? 'icon-card' : ''}`}>
            <div className={`card-view`}>
                <div className={`cta-header`}>
                    <div className={`d-flex flex-row`}>
                        <div className={`icon`} />
                        <div className={`text-wrapper`}>
                            <h5 className={`text-blue text-normal text-uppercase show-ellipsis blue-title`} data-testid={dataTestId && `${dataTestId}.title`}>{title}</h5>
                            <p className={`sub-title normal`} data-testid={dataTestId && `${dataTestId}.subtitle`}>{subTitle}</p>
                            <p className={`sub-title special`} data-testid={dataTestId && `${dataTestId}.icon-card-subtitle`}>{iconCardSubTitle || subTitle}</p>
                        </div>
                    </div>
                </div>
                <div className={`cta-divider`} />
                <div className={`cta-footer`}>
                    <button
                        type="button"
                        className={`btn btn-sm btn-blue`}
                        onClick={(ev) => onCtaClick(ev)}
                        data-testid={dataTestId && `${dataTestId}.cta-btn`}
                        {...getClickAttrs({
                            category: clickCategory,
                            context: clickLocation,
                            location: clickContext,
                        })}
                    >
                        {ctaText}
                    </button>
                </div>
            </div>
        </div>
    );
};

CtaCard.defaultProps = {
    'data-testid': null,
};

export default CtaCard;

export const CtaData = {
    POST_SCORE: {
        title: 'POST A SCORE',
        subTitle: 'Self-post scores from your matches.',
        ctaText: 'Post a Score',
    },
    FIND_EVENTS: {
        title: 'FIND AN EVENT',
        subTitle: 'Play in a level-based event near you.',
        ctaText: 'Find an event',
    },
    CREATE_PERSONAL_CLUB: {
        title: 'START YOUR PLAYERS GROUP',
        subTitle: 'Easily schedule tennis with your friends through UTR Sports',
        iconCardSubTitle: 'Easily schedule tennis with your friends through UTR Sports',
        ctaText: 'Schedule Play',
    },
    FIND_JOIN_CLUB: {
        title: 'FIND AND JOIN A CLUB',
        subTitle: 'Play in the club events and compare yourself to other members.',
        iconCardSubTitle: 'Play in the club’s events and compare yourself to other digital members.',
        ctaText: 'Find a Club',
    },
    SETUP_PLAYERS_TOUR_EVENT: {
        title: 'Set up your own $1K+ Players Initiative event',
        subTitle: 'UTR Sports will provide free software for any tournament with $1K+ in prize money',
        iconCardSubTitle: 'UTR Sports will provide free software for any tournament with $1K+ in prize money',
        ctaText: 'Create Event',
    },
    SUPPORT_ASPIRING_PLAYERS: {
        title: 'Donate to support aspiring tennis players',
        subTitle: 'Want to sponsor a $1K+ event or donate to support aspiring tennis players?',
        iconCardSubTitle: 'Want to sponsor a $1K+ event or donate to support aspiring tennis players?',
        ctaText: 'Donate',
    },
};
